export interface WorkspaceConfig {
  id: string;
  name: string;
}

export interface MockWorkspaceApp {
  id: string;
  label: string;
  icon: string;
}

export const INTERNAL_DEVELOPMENT_WORKSPACE_ID = "internal-development";

/**
 * A visual mockup of workspace switching. Every real app in the current
 * registry belongs to Internal Development; Partnership Intelligence and
 * Audience Intelligence are placeholders for workspaces that don't have live
 * apps yet.
 */
export const workspaces: WorkspaceConfig[] = [
  { id: INTERNAL_DEVELOPMENT_WORKSPACE_ID, name: "Internal Development" },
  { id: "partnership-intelligence", name: "Partnership Intelligence" },
  { id: "audience-intelligence", name: "Audience Intelligence" }
];

export const defaultWorkspaceId = INTERNAL_DEVELOPMENT_WORKSPACE_ID;

const mockWorkspaceApps: Record<string, MockWorkspaceApp[]> = {
  "partnership-intelligence": [
    {
      id: "evaluate",
      label: "Evaluate",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWZpbGUtcXVlc3Rpb24tbWFyayIgYXJpYS1oaWRkZW49InRydWUiPjxwYXRoIGQ9Ik02IDIyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDhhMi40IDIuNCAwIDAgMSAxLjcwNC43MDZsMy41ODggMy41ODhBMi40IDIuNCAwIDAgMSAyMCA4djEyYTIgMiAwIDAgMS0yIDJ6Ij48L3BhdGg+PHBhdGggZD0iTTEyIDE3aC4wMSI+PC9wYXRoPjxwYXRoIGQ9Ik05LjEgOWEzIDMgMCAwIDEgNS44MiAxYzAgMi0zIDMtMyAzIj48L3BhdGg+PC9zdmc+"
    },
    {
      id: "prospect",
      label: "Prospect",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWZpbGUtcXVlc3Rpb24tbWFyayIgYXJpYS1oaWRkZW49InRydWUiPjxwYXRoIGQ9Ik02IDIyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDhhMi40IDIuNCAwIDAgMSAxLjcwNC43MDZsMy41ODggMy41ODhBMi40IDIuNCAwIDAgMSAyMCA4djEyYTIgMiAwIDAgMS0yIDJ6Ij48L3BhdGg+PHBhdGggZD0iTTEyIDE3aC4wMSI+PC9wYXRoPjxwYXRoIGQ9Ik05LjEgOWEzIDMgMCAwIDEgNS44MiAxYzAgMi0zIDMtMyAzIj48L3BhdGg+PC9zdmc+"
    },
    {
      id: "contract",
      label: "Contract",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWZpbGUtcXVlc3Rpb24tbWFyayIgYXJpYS1oaWRkZW49InRydWUiPjxwYXRoIGQ9Ik02IDIyYTIgMiAwIDAgMS0yLTJWNGEyIDIgMCAwIDEgMi0yaDhhMi40IDIuNCAwIDAgMSAxLjcwNC43MDZsMy41ODggMy41ODhBMi40IDIuNCAwIDAgMSAyMCA4djEyYTIgMiAwIDAgMS0yIDJ6Ij48L3BhdGg+PHBhdGggZD0iTTEyIDE3aC4wMSI+PC9wYXRoPjxwYXRoIGQ9Ik05LjEgOWEzIDMgMCAwIDEgNS44MiAxYzAgMi0zIDMtMyAzIj48L3BhdGg+PC9zdmc+"
    }
  ],
  "audience-intelligence": []
};

export function getMockWorkspaceApps(workspaceId: string): MockWorkspaceApp[] {
  return mockWorkspaceApps[workspaceId] ?? [];
}
